import { Icon } from '@manychat/icons'
import { Icon as IconComponents } from '@manychat/manyui'

import { IButton } from 'common/builder/buttons/buttonInterfaces'
import { isUrlButton as getIsUrlButton } from 'common/builder/buttons/buttonTypeHelpers'
import { ButtonType } from 'common/builder/constants/ButtonType'

const IconMapping: Record<string, Icon> = {
  [ButtonType.BUY]: IconComponents.OrphanBuyButton,
  [ButtonType.CALL]: IconComponents.OrphanCall,
  [ButtonType.SHARE]: IconComponents.Share,
}

export const getButtonIcon = (entity: IButton): Icon | null => {
  const isUrlButton = getIsUrlButton(entity)

  if (isUrlButton) {
    return IconComponents.Link
  }

  if (entity.type in IconMapping) {
    return IconMapping[entity.type]
  }

  return null
}
